module.exports = __webpack_public_path__ + "static/media/neosho.6813e076.png";